import {
  IconButton,
  LinearGradient,
  Stack,
} from '@adc/parallax-component-library';

import MenuIcon from '~/icons/menu.svg?react';
import { buildTestId } from '~/utils/buildTestId';

type Props = {
  testID: string;
  hideSelectMenu?: boolean;
};

export const AppMenuItemButton = ({
  testID,
  hideSelectMenu = false,
}: Props) => (
  <Stack flexDirection="row" alignItems="center" testID={testID}>
    {!hideSelectMenu && (
      <IconButton
        testID={buildTestId({
          testID,
          suffix: 'select',
        })}
        aria-label="Select menu"
        variant="tertiary"
        size="XS"
        marginLeft="$2"
        onPress={() => {
          // Empty function to handle the button press
        }}
      >
        <MenuIcon
          size="XS"
          accentColor="$surface.brand"
          testID={buildTestId({ testID, suffix: ['select', 'icon'] })}
        />
      </IconButton>
    )}

    <LinearGradient
      colors={['#4E9FF8', '#007AFF']}
      start={{ x: 0, y: 0 }}
      end={{ x: 0, y: 1 }}
      borderRadius="$1.25"
      overflow="hidden"
      marginLeft={10}
      marginRight={14}
    >
      <Stack width={31} height={31} />
    </LinearGradient>
  </Stack>
);
